<template>
  <div class="col-12 col-md-12 col-lg-8 text-center">
    <div class="tit">
      <p>Documento de identidade (RG ou CNH) do(s) sócio(s)/avalista(s)</p>
    </div>
    <form>
      <div class="margin">
        <files-input :files="arquivos" :accept="formatosAceitos"
          :uploadEndpoint="uploadEndpoint" @files-changed="onFilesChanged"/>
      </div>
     <div class="text-center fixedOptions">
        <button @click="onSubmit" class="btn btn-lg btn-primary">Próximo<img src="../../assets/images/angle-right.svg"></button>
     </div>
    </form>
  </div>
</template>

<style scoped>
.margin {
  margin-bottom: 25px;
}
</style>

<script>
import FilesInput from '@/components/FilesInput'
import ArrayHelper from '@/utils/array-helper'

export default {
  components: {
    FilesInput
  },
  data() {
    return {
      /* eslint-disable */  
      uploadEndpoint: process.env.API_NODE+'/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: this.solicitacao.ArquivosIdentidade || [null]
    }
  },
  computed: {
    arquivosRecebidos: function() {
      return this.arquivos.filter(arquivo => {
        return arquivo != null && arquivo != undefined
      })
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles
    },
    removeFile(index) {
      this.arquivos.splice(index, 1)
    },
    clearFile(index) {
      this.$set(this.arquivos, index, null)
    },
    validate() {
      if(this.arquivosRecebidos.length > 0) {
        return {isValid: true, errors: []}
      } else {
        return {isValid: false, errors: ['O envio do documento de identidade de ao menos um avalista é obrigatório']}
      }
    },
    onSubmit(e) {
      e.preventDefault()
      const validation = this.validate()

      if(validation.isValid) {
        const newData = {
          ArquivosIdentidade: this.arquivosRecebidos
        }
        this.$emit('on-submit', newData)
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: ArrayHelper.toSentence(validation.errors)})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/EnvioIdentidadeStep.vue